import React from 'react';
import { useTranslation } from 'react-i18next';
import './_styles_/AmqpVhostsTableRow.css';
import { vhostType } from '../../types';
import { getConnectionStatus } from '../../utils/ConnectionStatuses';

AmqpVhostsTableRow.propTypes = {
    vhost: vhostType.isRequired,
};

function AmqpVhostsTableRow(props) {
    const {
        vhost,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="detail-list-row amqp-vhost-table-row">
            <div className="amqp-vhost-cell amqp-vhosts-table-row--virtual-host">{vhost.virtualHost}</div>
            <div className="amqp-vhost-cell amqp-vhosts-table-row--connection-status">{getConnectionStatus(vhost.connectionStatus).translate(t)}</div>
            <div className="amqp-vhost-cell amqp-vhosts-table-row--node">{vhost.nodeHostname}</div>
        </div>
    );
}

export default AmqpVhostsTableRow;
